import VueSlickCarousel from "vue-slick-carousel";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    components: { 'slick-carousel' : VueSlickCarousel },
    props: ['activetab'],
    data: () => {
        return {
            currentTab: '',
            slickSettings: {
                arrows: true,
                adaptiveHeight: false,
                draggable: true,
                slidesToScroll: 1,
                dots: true,
                infinite: false,
                speed: 300,
                variableWidth: false,
            }
        }
    },
    mounted() {
        this.currentTab = this.activetab;
        this.slickSettings.slidesToShow = Math.round($(".search-result-column").width() / 284);
    },
}
